// 포함된 기능

// ✅ 기존 이미지 + 신규 이미지 통합 관리
// ✅ 이미지 타입 관리 (대표 / 객실 / 욕실)
// ✅ 최대 10장 제한
// ✅ 멀티 업로드
// ✅ Drag & Drop 파일 업로드
// ✅ Drag 정렬 + placeholder UX
// ✅ 이미지 클릭 → 교체 업로드
// ✅ 미리보기 + 삭제
// ✅ 1MB 체크
// ✅ 800 기준 리사이즈 + 70% 압축
// ✅ width / height FormData 포함
// ✅ URL revoke 메모리 관리
// ✅ React.memo 카드 → 200장까지 성능 대응

import React, { useEffect } from "react";
import { RoomImage } from "./handlers";
import AddImageCard from "./addImgCard";
import TableRow from "components/rows/tableRow";
import UpdateFormHead from "components/subHead/updateFromHead";
import { useOnSubmit } from "./service";
import { useImagesContext } from "./context";
import ImageCard from "./imgCard";

interface Props {
  initialImages: RoomImage[];
  rmNo: string | null;
  formId: string;
  btnTxt: string;
}
const maxImages = 10;
const RoomImageManager: React.FC<Props> = ({
  initialImages,
  rmNo,
  formId,
  btnTxt,
}) => {
  const { images, setImages, setRmNo } = useImagesContext();

  const { onSubmit } = useOnSubmit();

  useEffect(() => {
    setRmNo(rmNo);
    setImages(
      initialImages.map((img) => ({
        id: String(img.rgSeq),
        rgSeq: img.rgSeq,
        expsOrdV: img.expsOrdV,
        preview: img.resImgPhUrl,
        origin: img,
        type: "existing",
      }))
    );
  }, [initialImages]);

  return (
    <>
      <UpdateFormHead title={"객실이미지"} formId={formId} btnTxt={btnTxt} />
      <form id={formId} onSubmit={onSubmit}>
        <table>
          <tbody>
            <TableRow title={"객실이미지"}>
              <ul>
                <li className="w-full h-auto">
                  <div style={{ width: "100%" }}>
                    <div className="grid [grid-template-columns:repeat(auto-fit,minmax(160px,auto))] gap-2 mt-5 justify-start">
                      {images
                        .filter((i) => i.type !== "deleted")
                        .map((img, index) => (
                          <ImageCard key={img.rgSeq} index={index} item={img} />
                        ))}
                      {images.length <= maxImages && (
                        <AddImageCard
                          formTyp={
                            formId.includes("create") ? "create" : "update"
                          }
                        />
                      )}
                    </div>
                  </div>
                </li>
              </ul>
            </TableRow>
          </tbody>
        </table>
      </form>
    </>
  );
};
export default RoomImageManager;
